import { defineComponent as _defineComponent } from 'vue'

import type { CloseEndedQuestion, Option } from '@ilteducation/exercise-service-types';

type Props = {
  item: CloseEndedQuestion;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ShowCloseEnded',
  props: {
    item: null
  },
  setup(__props: any) {

const props = __props as {
  item: CloseEndedQuestion;
}


const getItemColor = (opt: Option) => {
  if (opt.id === props.item.answer) {
    return '#4DB6AC';
  }
  return '#EF9A9A';
};
const getItemIcon = (opt: Option) => {
  if (opt.id === props.item.answer) {
    return 'mdi-checkbox-marked-circle';
  }
  return 'mdi-close-circle';
};

return { __sfc: true,props, getItemColor, getItemIcon }
}

})